/* eslint-disable @typescript-eslint/no-unused-vars */
import { ProjectModel, ProjectPermissions } from "api/project";

import { IUser } from "models/User";

export interface ApiProjectPermissions {
  canTransferOwnership?: boolean;
}

export const getProjectPermissions = (
  project: ProjectModel,
  user: Maybe<IUser>,
  isAtLeastPowerUser: boolean,
  isAtLeastAdmin: boolean,
  isReadonly: boolean,
  apiPermissions?: ApiProjectPermissions
): ProjectPermissions => {
  // Same absent-user guard as getDashboardPermissions: popout/standalone routes
  // can resolve a project before the user hydrates.
  const isOwner = !!user?.id && project?.owner === user.id;
  const viewable = true;
  let editable = false;
  let deletable = false;
  let canEditProjectItems = false;
  let canEditGroups = false;

  if (project) {
    if (isReadonly) {
      editable = false;
      canEditProjectItems = false;
      deletable = false;
    } else {
      canEditGroups = isAtLeastPowerUser;
      switch (project.projectType) {
        case "McDaniel":
          editable = false;
          canEditProjectItems = false;
          deletable = false;
          break;
        case "Organization":
          editable = isAtLeastPowerUser;
          canEditProjectItems = isAtLeastPowerUser;
          deletable = isAtLeastPowerUser;
          break;

        case "Shared":
          editable = isOwner || isAtLeastPowerUser;
          canEditProjectItems = !isReadonly;
          deletable = isOwner || isAtLeastPowerUser;
          break;

        case "Personal":
        default:
          editable = isOwner && project.projectName !== "Default";
          canEditProjectItems = isOwner;
          deletable = isOwner;
          break;
      }
    }
  }

  return {
    canCreate: !isReadonly,
    canView: viewable,
    canEdit: editable,
    canDelete: deletable,
    canEditProjectItems,
    canEditFilters: canEditProjectItems,
    canEditForecasts: canEditProjectItems,
    canEditShapefiles: canEditProjectItems,
    canEditTypeWells: canEditProjectItems,
    canEditGroups: canEditGroups,
    canTransferOwnership: apiPermissions?.canTransferOwnership ?? false
  };
};
